<template>
    <div class="page">
        <div class="blk1">
            <div class="circle">
                <svg class="svg-cir" viewBox="0 0 20 20" fill="transparent">
                    <circle :class="{'cir':true, 'ani-init':!timeAniStart, 'ani-start':timeAniStart}" />
                </svg>
                <div class="time">{{time}}</div>
            </div>
        </div>
        <div class="blk2" v-if="curQuestion">
            <div class="title">{{curIndex+1}}: {{curQuestion.title}}</div>
            <img class="qs-img" :src="curQuestion.image" alt="">
            <ul class="answer-list">
                <li v-for="(item, index) in curQuestion.options" :class="{'answer-item':true, 'answer-item-active':selectOption===index}" @click="_select(index)" :key="index">
                    <em>{{index|answerName}}. </em>{{item}}
                </li>
            </ul>
        </div>
        <div class="blk3">
            <div :class="{'btn':true, 'btn-block':true, 'gray':selectOption===null}" @click="_submitAnswer">အိုကေ</div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import config from '../config'
var timer = null;
var aniTimer = null;
var selectMap = ['A', 'B', 'C', 'D'];

export default {
    name: 'Answer',
    data(){
        return {
            list: [],
            curIndex: null,
            selectOption: null,
            time: null,
            timeAniStart: false,
            questionId: null,
        }
    },
    filters: {
        answerName(num){
            let map = ['A', 'B', 'C', 'D'];
            return map[num];
        }
    },
    computed: {
        ...mapState(['lang','langMap']),
        curQuestion(){
            return this.list[this.curIndex]
        }
    },
    created(){
        // if(!localStorage.getItem('A_rule')){
        //     localStorage.setItem('A_rule', 1);
        //     this.$router.push('/rule');
        //     return;
        // }
        var id = this.$route.query.id;
        Utils.$ajax({
            type: 'post',
            url: '/core/star',
            data: {id:id}
        }).done(res=>{
            if(res.code!=0 || !res.data || res.data.length == 0){
                this.$messagebox_lang('မေးခွန်းမလုံလောက်တော့ပါ');
                this.$router.go(-1);
                return;
            }
            res.data.forEach(item=>{
                item.options = item.options.split('|');
            })

            var curIndex = 0;
            this.questionId = res.data[0].question_id;
            this.list = res.data;
            this.curIndex = curIndex;
            this._startQt(curIndex);
        })
    },
    beforeDestroy(){
        timer && clearInterval(timer);
    },
    methods: {
        _startCountdown(time){
            // this._startTimeAni();
            this.time = time;
            timer && clearInterval(timer);
            timer = setInterval(()=>{
                if(this.time <= 0){
                    clearInterval(timer);
                    if(this.curIndex == this.list.length - 1){
                        // this._endAnswer(msg);
                        this.$router.replace(`/end?id=${this.questionId}`);
                    }else{
                        // this._answerMessage(msg);
                        this._startQt(++this.curIndex);
                    }
                }else{
                    this.time --;
                }
            }, 1000)
        },
        _startTimeAni(){
            aniTimer && clearTimeout(aniTimer);
            aniTimer = setTimeout(()=>{
                this.timeAniStart = true;
            },10);
        },
        _startQt(index){
            this.curIndex = index;
            this.selectOption = null;
            let item = this.list[index],
                reqData = {id: item.id};

            Utils.$ajax({
                type: 'post',
                url: '/core/count-down',
                data: reqData
            }).done(res=>{
                if(res.code != 0){
                    this.$toast(res.msg);
                    return;
                }

                this._startCountdown(res.data.countDown);
            })
        },
        _answerMessage(msg){
            // this.timeAniStart = false;
            this.$messagebox_lang(msg).then(()=>{
                this._startQt(++this.curIndex)
            })
        },
        _endAnswer(msg){
            // this.timeAniStart = false;
            this.$messagebox_lang(msg).then(()=>{
                this.$router.replace(`/end?id=${this.questionId}`);
            })
        },
        _select(i){
            this.selectOption = i;
        },
        _submitAnswer(){
            if(this.selectOption == null) return
            timer && clearInterval(timer);
            let reqData = {id: this.curQuestion.id, solution:selectMap[this.selectOption]}

            Utils.$ajax({
                type: 'post',
                url: '/core/process',
                data: reqData
            }).done(res=>{
                var msg = '';
                if(res.code != 0){
                    // msg = res.msg;
                }else{
                    // msg = res.data.msg;
                }
                if(this.curIndex == this.list.length - 1){
                    // this._endAnswer(msg);
                    this.$router.replace(`/end?id=${this.questionId}`);
                }else{
                    // this._answerMessage(msg);
                    this._startQt(++this.curIndex);
                }
            })
        }
    }
}

</script>
<style lang="scss" scoped>
    .page{
        padding: 0 1em;
    }
    .blk1{
        .circle{
            position: relative;
            width: rem(140);
            height: rem(140);
            border-radius: 50%;
            margin: 0 auto;
            background-color: #fff;
            text-align: center;

            .time{
                position: absolute;
                width: 100%;
                top: 0;
                left: 0;
                line-height: rem(140);
                color: #ff50b3;
                font-size: rem(70);
            }
        }
        .svg-cir{
            width: rem(140);
            height: rem(140);
            display: none;
            .cir{
                r: 8;
                cx: 10;
                cy: 10;
                stroke: #ff50b3;
                stroke-width: 2;
                stroke-dasharray: 3.14*2*8;
                transition-timing-function: linear;
                &.ani-init{
                    stroke-dashoffset: 0;
                    transition-duration: 0s;
                }
                &.ani-start{
                    stroke-dashoffset: 3.14*2*8;
                    transition-duration: 5s;
                }
            }
        }
    }
    .blk2{
        margin-top: rem(50);
        .title{
            font-size: rem(32);
        }
        .qs-img{
            display: block;
            max-width: rem(484);
            max-height: rem(245);
            margin: 0 auto;
        }
        .answer-list{
            margin-top: rem(50);
        }
        .answer-item{
            padding: rem(16) rem(30);
            border-radius: rem(45);
            background-color: #fff;
            font-size: rem(36);
            color: #000;
            margin-top: rem(30);
            em{
                font-size: rem(32);
                color: #555;
            }
            &:first-child{
                margin-top: 0;
            }
            &.answer-item-active{
               background-color: #ff50b3;
               color: #fff;
            }
        }
    }
    .blk3{
        margin-top: rem(50);
    }
</style>



// WEBPACK FOOTER //
// src/components/Answer.vue